import { render } from "./IconAdv2.vue?vue&type=template&id=1281069a&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconAdv2.vue?vue&type=script&lang=js"
export * from "./IconAdv2.vue?vue&type=script&lang=js"
script.render = render

export default script